import React, { useCallback, useReducer } from "react";
import { reducerFn } from "../../../helper";
import TiktokMarkAsOrderLabel from "./tiktok-mark-as-order-label";
import TiktokDuplicateOrder from "./tiktok-duplicate-order";
import { ActionList, Button, Popover } from "@shopify/polaris";
import TiktokMarkSplitTag from "./tiktok-mark-split-tag";

function TiktokMoreAction({ item, refetch }) {
    const [state, setState] = useReducer(reducerFn, {
        open: false,
        openModal: false,
        action: null,
    });

    const handleActionChange = useCallback(
        (action) => () => {
            setState({ openModal: true, action });
        },
        [],
    );

    const handleClose = useCallback(() => {
        setState({ open: false, openModal: false, action: null });
    }, []);

    const handleClosePopover = useCallback(() => {
        setState({ open: false });
    }, []);

    const handleClick = useCallback(() => {
        setState({ open: true });
    }, []);

    const activator = (
        <Button disclosure children="Actions" onClick={handleClick} />
    );

    const actions = [
        {
            content: "Duplicate",
            onAction: handleActionChange("duplicate"),
        },
        {
            content: "Mark As Order Label",
            onAction: handleActionChange("markAsOrderLabel"),
        },
        {
            content: "Mark As Order Label Split",
            onAction: handleActionChange("markSplitTag"),
        },
    ];

    const handleCompleted = useCallback(() => {
        handleClose();
        refetch && refetch();
    }, [handleClose, refetch]);

    const props = {
        ids: item?.id ? [item.id] : [],
        open: state.openModal,
        item,
        onCompleted: handleCompleted,
        onClose: handleClose,
    };

    const actionMarkup = {
        duplicate: <TiktokDuplicateOrder {...props} />,
        markAsOrderLabel: <TiktokMarkAsOrderLabel {...props} />,
        markSplitTag: <TiktokMarkSplitTag {...props} />,
    };

    return (
        <>
            <Popover
                activator={activator}
                active={state.open}
                onClose={handleClosePopover}
            >
                <ActionList items={actions} />
            </Popover>
            {actionMarkup[state.action]}
        </>
    );
}

export default TiktokMoreAction;
